import React, { useState } from 'react';
import styles from './SearchGroup.module.css';

const SearchGroup = ({ onPrev, onSubmit }) => {
  const [groupCode, setGroupCode] = useState('');
  
  const handleSubmit = () => {
    // Placeholder for backend logic
    onSubmit();
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <label>Search Group By Code</label>
        <input
          type="text"
          value={groupCode}
          onChange={(e) => setGroupCode(e.target.value)}
          placeholder="Enter group code"
        />

        <div className={styles.groupInfo}>
          <span className={styles.groupName}>Back Bay Homies</span>
          <button className={styles.requestButton}>Request to Join</button>
        </div>
      </div>

      <div className={styles.rightSection}>
        <div className={styles.createGroup}>
          <span className={styles.plusIcon}>+</span>
          <span>Create Group</span>
        </div>
      </div>
    </div>
  );
};

export default SearchGroup;
